var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('addressSelect',{ref:"orgInfoAddress",attrs:{"provice":'org'},on:{"proviceSE":_vm.proviceSE}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }